<template>
  <div class="delivery-info">
    <div class="disable-cover" v-if="orderStatus === OrderDeleted" />
    <basic-form
      ref="deliveryInfo"
      title="Delivery Info"
      :mode="FormModes.SPARSE"
      :form-params="whatToShow"
    >
      <template v-slot:actions>
        <el-button
          size="small"
          type="primary"
          :disabled="orderStatus === OrderDeleted"
          plain
          @click="editing = true"
          v-if="!editing && editable"
        >
          Edit
        </el-button>
        <el-button
          size="small"
          type="primary"
          plain
          @click="saveInfo"
          v-if="editing && editable"
        >
          Save
        </el-button>
        <el-button
          size="small"
          type="danger"
          plain
          @click="editing = false"
          v-if="editing && editable"
        >
          Cancel
        </el-button>
      </template>
    </basic-form>
  </div>
</template>
<script>
import cloneDeep from 'lodash/cloneDeep'
// others
import { FormModes } from '@/core/configs/types'
// msg
import PagesMessage from '@/core/message/pages'
// models
import {
  OrderCreated,
  OrderDeleted,
  DirectDeliveryInfoWrapUp,
  DirectDeliveryInfoForm
} from '@/core/models/order'
// apis
import { modifyOrder } from '@/api/order'
// components
import BasicForm from '@/components/common/BasicForm.vue'
export default {
  name: 'ContainerInfo',
  components: {
    BasicForm
  },
  props: {
    orderId: {
      type: String,
      required: true
    },
    orderStatus: {
      type: String,
      default: OrderCreated
    },
    editable: {
      type: Boolean,
      default: true
    },
    deliveryInfo: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      FormModes,
      OrderDeleted,
      editing: false
    }
  },
  mounted() {},
  computed: {
    whatToShow() {
      return this.editing ? this.editInfo : this.viewInfo
    },
    viewInfo() {
      const a = DirectDeliveryInfoWrapUp(this.deliveryInfo)
      return a
    },
    editInfo() {
      const form = cloneDeep(DirectDeliveryInfoForm)
      Object.values(form).forEach(one => {
        one.value = this.deliveryInfo[one.key]
      })
      return form
    }
  },
  methods: {
    saveInfo() {
      const [formPassed, directDeliveryInfo] =
        this.$refs.deliveryInfo.validateAllInputs()
      if (formPassed) {
        this.$confirm('Change Delivery info', 'Warning', {
          showCancelButton: false,
          confirmButtonText: 'OK',
          type: 'warning'
        })
          .then(() => {
            modifyOrder(this.orderId, {
              directDeliveryInfo
            }).then(res => {
              if (res) {
                this.editing = false
                PagesMessage.emit(PagesMessage.eventMap.REFRESH_ORDER_DETAIL)
              }
            })
          })
          .catch(() => {})
      }
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/assets/styles/common.scss';

.delivery-info {
  position: relative;
}
</style>
